import SimpleModal from '../SimpleModal';
import {Formik} from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

const FormEntityModal = ({
													 initialValues,
													 submitHandler,
													 formRender,
													 title,
													 schema,
													 trigger
												 }) => {
	return (
		<SimpleModal
			title={title}
			trigger={trigger}
			open={false}
			render={setOpen => (
				<Formik
					initialValues={{ ...initialValues }}
					render={formRender(() => setOpen(false))}
					enableReinitialize
					validateOnChange
					validateOnBlur
					validationSchema={schema}
					onSubmit={(values, actions) => {
						submitHandler(values);
						actions.setSubmitting(false);
						setOpen(false);
					}}
				/>
			)}
		/>
	);
};

FormEntityModal.propTypes = {
	title: PropTypes.string.isRequired,
	initialValues: PropTypes.shape({}).isRequired,
	submitHandler: PropTypes.func.isRequired,
	formRender: PropTypes.func.isRequired,
	trigger: PropTypes.func.isRequired,
	schema: PropTypes.object.isRequired
};

export default FormEntityModal;
